module.exports = __webpack_public_path__ + "static/media/removeTagImg.26207875.svg";